/**
 * 「城郊」这一圈的器物：别人家门口的破烂、垃圾源、容器、装修污染的桶。
 *
 * state.parent 指名它在 systems/loot.js 里对应的货单（这一类容器能翻出什么）。
 * interact.action 统一走 actions.js 里已有的 handler，不新开口子。
 */

/** 载具：人家门口摆着的那种，多半还能拆出点东西 */
export const VEHICLE_PROPS = {
  part_bus: {
    name: '锈住的公交壳子', w: 3, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '锈住的公交壳子', hint: 'E 翻找' },
    desc: '一层浮锈，一半零件早被人卸走了。', state: { parent: '废车', level: 3 },
  },
  ruined_sedan: {
    name: '报废轿车', w: 3, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '报废轿车', hint: 'E 翻找' },
    desc: '窗玻璃碎了一地。', state: { parent: '废车', level: 2 },
  },
  flatbed_tricycle: {
    name: '农用三蹦子', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '农用三蹦子', hint: 'E 翻找' },
    desc: '车斗里还垫着草。', state: { parent: '废车', level: 1 },
  },
  rickshaw: {
    name: '人力车', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '人力车', hint: 'E 翻找' },
    desc: '轮子歪了，坐垫倒是还在。', state: { parent: '废车', level: 1 },
  },
  wheelbarrow: {
    name: '独轮车', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '独轮车', hint: 'E 翻找' },
    desc: '推起来吱呀响。', state: { parent: '废车', level: 1 },
  },
  oil_drum: {
    name: '大油桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '大油桶', hint: 'E 翻找' },
    desc: '空的，敲一记当当响。', state: { parent: '废车', level: 1 },
  },
  jet_ski: {
    name: '私人快艇', w: 3, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '私人快艇', hint: 'E 翻找' },
    desc: '不知怎么漂到这儿来的。', state: { parent: '废车', level: 4 },
  },
};

/** 垃圾源：便宜的最大来源，也是最容易弄脏的地方 */
export const JUNK_PROPS = {
  tire_pile: {
    name: '轮胎堆', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '轮胎堆', hint: 'E 翻找' },
    desc: '堆得半人高，底下压着东西。', state: { parent: '轮胎堆', dirty: 3, stink: 2 },
  },
  junk_pile: {
    name: '垃圾堆', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '垃圾堆', hint: 'E 翻找' },
    desc: '永远不会让你空手而归。', state: { parent: '垃圾堆', dirty: 3, stink: 3 },
  },
  scrap_heap: {
    name: '废铁堆', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '废铁堆', hint: 'E 翻找' },
    desc: '能卖钱的都在最底下。', state: { parent: '废铁堆', dirty: 2, stink: 1 },
  },
  building_waste: {
    name: '大件建筑垃圾', w: 3, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '大件建筑垃圾', hint: 'E 翻找' },
    desc: '翻的时候邻居会多看两眼。', state: { parent: '建筑垃圾', dirty: 4, stink: 1 },
  },
  roadside_mailbox: {
    name: '路边旧信箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '路边旧信箱', hint: 'E 翻找' },
    desc: '锁早就坏了。', state: { parent: '垃圾堆', dirty: 1, stink: 1 },
  },
  lot_bucket: {
    name: '泔水桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '泔水桶', hint: 'E 翻找' },
    desc: '酸得辣眼睛。', state: { parent: '泔水桶', dirty: 3, stink: 5 },
  },
  hospital_bin: {
    name: '社区医疗垃圾桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '社区医疗垃圾桶', hint: 'E 翻找' },
    desc: '黄盖子白桶身，翻它最好戴着手套。', state: { parent: '医疗垃圾桶', dirty: 2, stink: 3 },
  },
  household_bin: {
    name: '垃圾桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '垃圾桶', hint: 'E 翻找' },
    desc: '邻居们什么都往里扔。', state: { parent: '垃圾桶', dirty: 2, stink: 2 },
  },
  medicine_box: {
    name: '医疗点的药箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '医疗点药箱', hint: 'E 翻找' },
    desc: '翻完记得把盖子合上。', state: { parent: '药箱', dirty: 1, stink: 1 },
  },
  ash_pile: {
    name: '灰堆', w: 1, h: 1, solid: false, layer: 'floor',
    interact: { action: 'scavenge', label: '灰堆', hint: 'E 翻找' },
    desc: '还有火星子没灭透。', state: { parent: '灰堆', dirty: 4, stink: 1 },
  },
  ash_burning_pit: {
    name: '烧灰坑', w: 2, h: 1, solid: false, layer: 'floor',
    interact: { action: 'scavenge', label: '烧灰坑', hint: 'E 翻找' },
    desc: '底下还热着。', state: { parent: '灰堆', dirty: 4, stink: 2 },
  },
  tire_iron: {
    name: '撬棍箱斗', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'salvage', label: '撬棍箱斗', hint: 'E 拆解' },
    desc: '塑料被太阳晒脆了。', state: { parent: '废铁堆', dirty: 1, stink: 1 },
  },
};

/** 容器：难开的那几个才藏着好东西 */
export const CONTAINER_PROPS = {
  unmarked_crate: {
    name: '无标识的废木箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '无标识废木箱', hint: 'E 翻找' },
    desc: '撬开不难。', state: { parent: '建筑垃圾', dirty: 1, stink: 0 },
  },
  locked_toolbox: {
    name: '上锁的工具箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '上锁的工具箱', hint: 'E 翻找' },
    desc: '锁是新的。', state: { parent: '工具箱', dirty: 1, stink: 0 },
  },
  locked_first_aid_kit: {
    name: '上锁的医药箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '上锁医药箱', hint: 'E 翻找' },
    desc: '白底红十字。', state: { parent: '医药箱', dirty: 0, stink: 1 },
  },
  locked_crate: {
    name: '上锁的板条箱', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '上锁板条箱', hint: 'E 翻找' },
    desc: '木板缝里能看见一角布。', state: { parent: '板条箱', dirty: 1, stink: 1 },
  },
  bolted_box: {
    name: '上螺栓的箱子', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '上螺栓箱', hint: 'E 翻找' },
    desc: '一颗颗拧，得拧很久。', state: { parent: '螺栓箱', dirty: 1, stink: 0 },
  },
  nailed_box: {
    name: '钉死的箱子', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '钉死的箱子', hint: 'E 翻找' },
    desc: '钉子钉得很满。', state: { parent: '钉死的箱子', dirty: 2, stink: 0 },
  },
  sealed_box: {
    name: '封条纸箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '封条纸箱', hint: 'E 翻找' },
    desc: '封条完整，撕了就要留痕迹。', state: { parent: '封条纸箱', dirty: 1, stink: 0 },
  },
  tattered_sack: {
    name: '破麻袋', w: 1, h: 1, solid: false, layer: 'floor',
    interact: { action: 'scavenge', label: '破麻袋', hint: 'E 翻找' },
    desc: '地上鼓鼓囊囊一包。', state: { parent: '垃圾堆', dirty: 2, stink: 1 },
  },
  rusted_sealed_drum: {
    name: '锈蚀的密封罐', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '锈蚀密封罐', hint: 'E 翻找' },
    desc: '晃一晃，里面有响动。', state: { parent: '密封罐', dirty: 2, stink: 2 },
  },
  locked_shed: {
    name: '上锁的工具棚', w: 2, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '上锁的工具棚', hint: 'E 翻找' },
    desc: '一把挂锁守着门。', state: { parent: '工具棚', dirty: 2, stink: 0 },
  },
  locked_display_case: {
    name: '上锁的玻璃展示柜', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '玻璃展示柜', hint: 'E 看看' },
    desc: '最贵的几件锁在里面。', state: { parent: '展示柜', dirty: 0, stink: 0 },
  },
};

/** 装修污染：这一带的脏源 headquarter */
export const DIRTY_PROPS = {
  oil_drum_unlabeled: {
    name: '无标识的油桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '无标识油桶', hint: 'E 翻找' },
    desc: '闻不出来里头是什么。', state: { parent: '油桶', dirty: 4, stink: 4 },
  },
  oil_drum_labeled: {
    name: '有标识的油桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '有标识油桶', hint: 'E 翻找' },
    desc: '桶身上贴着张看不清的纸。', state: { parent: '油桶', dirty: 3, stink: 3 },
  },
  fireworks_bucket: {
    name: '硝酸钾肥料桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '肥料桶', hint: 'E 翻找' },
    desc: '受潮结块了。', state: { parent: '肥料桶', dirty: 3, stink: 2 },
  },
  solvent_bucket: {
    name: '稀料桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '稀料桶', hint: 'E 翻找' },
    desc: '味道冲得人头晕。', state: { parent: '稀料桶', dirty: 4, stink: 5 },
  },
  paint_bucket: {
    name: '漆桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '漆桶', hint: 'E 翻找' },
    desc: '半桶漆结了一层皮。', state: { parent: '漆桶', dirty: 4, stink: 3 },
  },
  chemical_drum: {
    name: '化学桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '化学桶', hint: 'E 翻找' },
    desc: '桶身上画着一个骷髅。', state: { parent: '化学桶', dirty: 5, stink: 5 },
  },
  burning_barrel: {
    name: '燃烧的铁桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'cook', label: '燃烧的铁桶', hint: 'E 就着烤点东西' },
    desc: '夜里它是这一带最亮的地方。', state: { parent: '灰堆', dirty: 2, stink: 1 },
  },
  brazier: {
    name: '火盆', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'cook', label: '火盆', hint: 'E 就着烤点东西' },
    desc: '炭火红得刚好。', state: { parent: '灰堆', dirty: 1, stink: 0 },
  },
  soaked_box: {
    name: '浸透的破纸箱', w: 1, h: 1, solid: false, layer: 'floor',
    interact: { action: 'scavenge', label: '浸透的破纸箱', hint: 'E 翻找' },
    desc: '一拎就散架。', state: { parent: '泔水桶', dirty: 4, stink: 4 },
  },
  moldy_rug: {
    name: '发霉地毯', w: 2, h: 1, solid: false, layer: 'floor',
    interact: { action: 'scavenge', label: '发霉地毯', hint: 'E 翻找' },
    desc: '掀开一角，底下什么都可能有。', state: { parent: '浸水发霉的家居地毯', dirty: 4, stink: 4 },
  },
  tattered_quilt: {
    name: '破棉被', w: 1, h: 1, solid: false, layer: 'floor',
    interact: { action: 'sleep', label: '破棉被', hint: 'E 将就一夜' },
    desc: '午后返潮，被面有点黏。', state: { parent: '破棉被', dirty: 3, stink: 3 },
  },
  withered_tree_stump: {
    name: '枯树墩', w: 1, h: 1, solid: false, layer: 'floor',
    interact: { action: 'sit', label: '枯树墩', hint: 'E 坐下歇脚' },
    desc: '锯口很平，坐上去正合适。', state: { parent: '垃圾堆', dirty: 1, stink: 0 },
  },
};
